import { thunk } from 'easy-peasy';
import api from '~/services/api';
import { IThunkGetTriageCounters } from '../types';

const onGetTriageCounters: IThunkGetTriageCounters = thunk(
  // @ts-ignore
  async ({ setCounters }) => {
    const data = await api.triage.getCounters().then(res => res.data);

    setCounters(data);
  },
);

export default onGetTriageCounters;
